import { Component, Input, ChangeDetectionStrategy, Injector } from '@angular/core'
import { Store } from '@ngrx/store'
import { NavController } from 'ionic-angular'
import { UIEventHub } from '../../../services/event.service'
import { ActionCreator } from '../../../services/action.service'
import { ViewModel } from '../../../view-model'
import { BaseWidget } from '../../base-widget'
import { ViewChild } from '@angular/core'
import { EChartsComponent, ILegend } from '@ar2/common'
import * as moment from 'moment'
/**
 * グラフ
 *【オプション:option:{graph_key:string, graph_option:string}】
 *【開始年月:startYrMon:string】
 *【一覧表示:showGroup:boolean】
 *【選択値:selectedValue:{year_month:string, series_index:string}】
 *【表示単位:displayUnit:number】
 *【凡例:legends:ILegend[]】
 * @author nabla2.metamodel.generator
 */
@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'app-graph-basic',
  templateUrl: './graph-basic.html',
  styles: [`
    .chart-area {
      height: 85vh;
    }
    .chart-area-group {
      height: 100%;
    }
  `]
})
export class GraphBasic extends BaseWidget {
  /**
   * 選択値の表示モデルパス
   */
  @Input() viewModelPath:string

  /**
   * 選択値に対する精査エラー
   */
  @Input() errorMessages:{modelPath:string, message:string}[]

  /**
   * 開始年月
   */
  @Input() startYrMon:string

  /**
   * 一覧表示
   */
  @Input() showGroup:boolean

  /**
   * 選択値
   */
  @Input() selectedValue:{year_month:string, series_index:string}

  /**
   * 表示単位
   */
  @Input() displayUnit:number

  /**
   * 凡例
   */
  @Input() legends:ILegend[]

  /**
   * コンストラクタ
   * @param navCtrl 画面遷移管理サービス
   * @param store Reduxストア
   */
  constructor(
    public navCtrl: NavController,
    public store: Store<{viewModel:ViewModel}>,
    public eventHub: UIEventHub,
    public actionCreator: ActionCreator,
    public injector: Injector,
  ) {
    super(injector)
  }
  /**
   * グラフのキー
   */
  private _key : string
  /**
   * オプションのJSONオブジェクト
   */
  private _option : any
  
  /**
   * オプション
   */
  @Input()
  set option(option : {graph_key: string, graph_option: string}) {
    if (!!option) {
      this._key = option.graph_key
      this._option = !!option.graph_option ? JSON.parse(option.graph_option) : null
    }
  }
  
  /**
   * The chart component
   *
   * @type {EChartsComponent}
   * @memberof GraphBasic
   */
    
  @ViewChild('chart')
  public chart: EChartsComponent;
      
  /**
   * Event handler for the chart ready
   *
   * @memberof GraphBasic
   */
  public onChartReady(chart:any) {
    this.chart = chart;
    const setting = chart.getOptionSetting();
    if (this.showGroup && setting.option.title && setting.option.title.textStyle) {
      setting.option.title.textStyle.fontSize = 15
    }
    if (this.displayUnit > 0){
      const self = this;
      setting.option.yAxis.forEach(function(yAxis) {
        yAxis.axisLabel['formatter'] = (value: any, index: any) => {
          if (index === 0) {
            return '';
          }
          if (self.displayUnit > 0) {
            if (value > self.displayUnit) {
              return String(Math.floor(value/self.displayUnit)).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,');
            }
          }
          return value;
        }
      });
    }
    setting.refresh();
  }
  
  /**
   * Event handler for click
   *
   * @memberof GraphBasic
   */
  public onClick(event) {
    if (this.showGroup) {
      this.store.dispatch(this.actionCreator.updateViewModel(
        this.viewModelPath,
        (m) => this._key,
        {id:this.id, type:event.type, source:new Event(event.type)},
        `update by ${this.id}`,
      ))
      this.on(event)
    }
  }
  
  /**
   * Event handler for the chart clicked
   *
   * @memberof GraphBasic
   */
  public onClickChart(chart) {
    if (!this.showGroup && !!this.startYrMon && this.startYrMon.length === 6) {
      const year = Number(this.startYrMon.substr(0, 4))
      const month = Number(this.startYrMon.substr(4))
      const date:Date = new Date(year, month - 1)
      date.setMonth(date.getMonth() + chart.dataIndex)
  
      const selectedYrMon = moment(date).format('YYYYMM')
      const selectedValue = {"year_month":selectedYrMon, "series_index":chart.seriesId.slice(-1)[0]}
  
      this.store.dispatch(this.actionCreator.updateViewModel(
        this.viewModelPath,
        (m) => selectedValue,
        {id:this.id, type:'click_chart', source:new Event('click_chart')},
        `update by ${this.id}`,
      ))
      this.on('click_chart')
    }
  }
  /**
   * このコンポーネントの状態をバインドされた表示項目の状態に反映する。
   * @param event イベント
   */
  update(event:Event) {
    const node = <HTMLFormElement>event.target
    const value = node.value
    this.store.dispatch(this.actionCreator.updateViewModel(
      this.viewModelPath,
      (m) => value,
      {id:this.id, type:event.type, source:event},
      `update by ${this.id}`,
    ))
    this.on(event)
  }
}


// WEBPACK FOOTER //
// ./src/widgets/graph/graph-basic/graph-basic.component.ts